import script from "./BinaryValueSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./BinaryValueSwitch.vue?vue&type=script&setup=true&lang=js"

import "./BinaryValueSwitch.vue?vue&type=style&index=0&id=aedb4aa0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aedb4aa0"]])

export default __exports__